import axios from "@/axios";

export default {
  list() {
    return axios.get("/user/roles/");
  },
  get(id) {
    return axios.get(`/user/roles/${id}/`);
  },
  create(data) {
    return axios.post("/user/roles/", data);
  },
  update(id, data) {
    return axios.put(`/user/roles/${id}/`, data);
  }
};
